import React from "react";

const AmExLargeIcon = () => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="American Express"
    >
      <g clipPath="url(#clip0_amex_large)">
        <g clipPath="url(#clip1_amex_large)">
          <path
            d="M32.868 21.376L31.204 19.52L29.4761 21.376H26.084H18.788V12.736H15.396L19.62 3.072H23.7161L25.188 6.4V3.072H30.3079L31.204 5.568L32.1 3.072H36.004V1.6C36.004 0.704 35.2999 0 34.404 0H0.0999999C-0.795999 0 -1.5 0.704 -1.5 1.6V22.4C-1.5 23.296 -0.795999 24 0.0999999 24H34.404C35.2999 24 36.004 23.296 36.004 22.4V21.376H32.868Z"
            fill="#0071CE"
          />
          <path
            d="M33.3161 20.352H36.004L32.484 16.576L36.004 12.864H33.38L31.14 15.296L28.9639 12.864H26.2759L29.86 16.64L26.2759 20.352H28.9L31.14 17.92L33.3161 20.352Z"
            fill="#0071CE"
          />
          <path
            d="M21.9878 18.624V17.472H26.2118V15.744H21.9878V14.592H26.2759V12.864H19.9398V20.352H26.2759V18.624H21.9878Z"
            fill="#0071CE"
          />
          <path
            d="M34.02 11.776H35.94V4.224L32.868 4.288L31.204 8.96L29.4761 4.288H26.2759V11.776H28.3241V6.528L30.244 11.776H32.036L34.02 6.528V11.776Z"
            fill="#0071CE"
          />
          <path
            d="M23.012 4.28796H20.388L17.06 11.776H19.2999L19.94 10.304H23.396L24.036 11.776H26.34L23.012 4.28796ZM20.6439 8.57596L21.6679 6.14396L22.692 8.57596H20.6439Z"
            fill="#0071CE"
          />
          <path
            d="M34.148 16.3839L36.004 18.432V14.3359L34.148 16.3839Z"
            fill="#0071CE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_amex_large">
          <rect width="36" height="24" rx="1.5" fill="white" />
        </clipPath>
        <clipPath id="clip1_amex_large">
          <rect width="36" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AmExLargeIcon;
